import { ChangeDetectionStrategy, Component, input, numberAttribute } from '@angular/core';
import { InputFieldBaseComponent } from './input-field-base.component';
import { MatError, MatFormField, MatHint, MatLabel, MatPrefix } from '@angular/material/form-field';
import { NgStyle } from '@angular/common';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'mng-inputfield-string',
  imports: [
    MatFormField,
    MatLabel,
    MatPrefix,
    NgStyle,
    ExtendedModule,
    MatInput,
    ReactiveFormsModule,
    MatIcon,
    MatHint,
    MatError
  ],
  template: `
    <mat-form-field
      style="width: 100%; {{ inputTextStyle() }}"
      [ngStyle]="ngStyle()"
      [appearance]="appearance()"
      [subscriptSizing]="subscriptSizing()"
      [floatLabel]="floatLabel()"
    >
      @if (field().label) {
        <mat-label style="text-transform: none;">{{ field().label }}</mat-label>
      }

      <input
        #input
        matInput
        autocomplete="off"
        [id]="field().id"
        [formControl]="field().control"
        [placeholder]="field().placeHolder"
        (keyup)="onKeyEvent($event)"
      />

      @if (prefix()) {
        <span matTextPrefix>&nbsp;{{ prefix() }}</span>
      }

      @if (iconName()) {
        <mat-icon matIconPrefix style="height: 20px;" [svgIcon]="iconName()" />
      }

      @if (hint()) {
        <mat-hint>{{ hint() }}</mat-hint>
      }
      @if (showLengthHint()) {
        <mat-hint align="end"> {{ input.value.length }} / {{ showLengthHint() }} </mat-hint>
      }

      @if (hasErrors) {
        <mat-error style="text-transform: none;"> {{ validationMessage }}</mat-error>
      }
    </mat-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFieldStringComponent extends InputFieldBaseComponent {
  readonly showLengthHint = input(undefined, { transform: numberAttribute });
  readonly hint = input<string>();
  readonly prefix = input<string | undefined>();
}
